export default __webpack_public_path__ + "static/media/feedback-form.1a37ade1.svg";